import { render } from "./FooterPanelSmartPhone.vue?vue&type=template&id=2daa4ff7&scoped=true"
import script from "./FooterPanelSmartPhone.vue?vue&type=script&lang=js"
export * from "./FooterPanelSmartPhone.vue?vue&type=script&lang=js"

import "./FooterPanelSmartPhone.scss?vue&type=style&index=0&id=2daa4ff7&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2daa4ff7"]])

export default __exports__